/* SG CART DRAWER — gamified rewards bar
   - Renders from /cart.js client-side (lives in layout, works every page)
   - Opens on cart-icon click + after successful AJAX add-to-cart
   - Qty steppers & remove via /cart/change.js
   - 300ms slide, Esc/overlay close, scroll lock
   Hooks sgc-commerce.js ATC by wrapping window.fetch and dispatching
   'sg:cart:added' after any successful POST to /cart/add. */
(function () {
  'use strict';
  if (window.__sgDrawerInit) return;
  window.__sgDrawerInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var drawer, overlay, body, itemsEl, emptyEl, loadingEl, footerEl, totalEl,
      rewardsEl, rewardStatus, rewardFill, nodeMid, nodeEnd;
  var SHIP_THRESHOLD = 15000, ITEM_THRESHOLD = 3, CURRENCY = 'USD';
  var lastFocus = null;

  function moneyFmt(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function cache() {
    drawer = $('[data-sg-drawer]');
    if (!drawer) return false;
    overlay = $('[data-sg-drawer-overlay]');
    body = $('[data-sg-drawer-body]', drawer);
    itemsEl = $('[data-sg-drawer-items]', drawer);
    emptyEl = $('[data-sg-drawer-empty]', drawer);
    loadingEl = $('[data-sg-drawer-loading]', drawer);
    footerEl = $('[data-sg-drawer-footer]', drawer);
    totalEl = $('[data-sg-drawer-total]', drawer);
    rewardsEl = $('[data-sg-rewards]', drawer);
    rewardStatus = $('[data-sg-reward-status]', drawer);
    rewardFill = $('[data-sg-reward-fill]', drawer);
    nodeMid = $('[data-sg-node-mid]', drawer);
    nodeEnd = $('[data-sg-node-end]', drawer);
    SHIP_THRESHOLD = parseInt(drawer.getAttribute('data-ship-threshold') || '15000', 10);
    /* 2026-10-20 Magenta: US$150 converted with the store's live rate */
    if (drawer.getAttribute('data-ship-usd') === '1') {
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      SHIP_THRESHOLD = Math.ceil(SHIP_THRESHOLD * rate / 100) * 100;
    }
    ITEM_THRESHOLD = parseInt(drawer.getAttribute('data-item-threshold') || '3', 10);
    CURRENCY = drawer.getAttribute('data-currency') || 'USD';
    return true;
  }

  /* ── open / close ── */
  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    // force reflow so transition runs
    void drawer.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('sg-drawer-open');
    var closeBtn = $('[data-sg-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
    refresh();
  }
  function close() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sg-drawer-open');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) overlay.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ── rewards / gamified bar ── */
  function renderRewards(cart) {
    if (!rewardsEl) return;
    if (cart.item_count === 0) { rewardsEl.hidden = true; return; }
    rewardsEl.hidden = false;

    var count = cart.item_count;
    var total = cart.total_price;
    var itemsDone = count >= ITEM_THRESHOLD;
    var shipRemaining = Math.max(0, SHIP_THRESHOLD - total);
    var shipDone = shipRemaining === 0;

    // combined fill: 0–33% = items toward 25% off node (mid), 33–100% = amount toward free ship (end)
    var pct;
    if (!itemsDone) {
      pct = (count / ITEM_THRESHOLD) * 33;
    } else if (!shipDone) {
      pct = 33 + (total / SHIP_THRESHOLD) * 67;
    } else {
      pct = 100;
    }
    pct = Math.min(100, Math.round(pct));
    rewardFill.style.width = pct + '%';
    rewardFill.classList.toggle('is-complete', pct >= 100);

    nodeMid.classList.toggle('is-lit', itemsDone);
    nodeEnd.classList.toggle('is-lit', shipDone);

    var html;
    if (!itemsDone) {
      var need = ITEM_THRESHOLD - count;
      html = 'Add <strong>' + need + ' more item' + (need !== 1 ? 's' : '') + '</strong> to unlock <strong>25% Off</strong>';
    } else if (!shipDone) {
      html = '<span class="sg-rewards__done">25% Off unlocked</span> &middot; Add <strong>' + moneyFmt(shipRemaining) + '</strong> for <strong>Free DHL Standard Shipping</strong>';
    } else {
      html = '<span class="sg-rewards__done">25% Off</span> &middot; <span class="sg-rewards__done">Free DHL Standard Shipping unlocked</span>';
    }
    rewardStatus.innerHTML = html;
  }

  /* ── line items ── */
  function renderLine(item) {
    var li = document.createElement('li');
    li.className = 'sg-line';
    li.setAttribute('data-key', item.key);

    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : '';
    var variant = '';
    if (item.product_has_only_default_variant === false && item.options_with_values) {
      variant = item.options_with_values.map(function (o) {
        return o.name + ': <span>' + o.value + '</span>';
      }).join(' · ');
    } else if (item.variant_title) {
      variant = 'Size: <span>' + item.variant_title + '</span>';
    }

    li.innerHTML =
      '<a class="sg-line__thumb" href="' + item.url + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="72" height="86">' : '') +
      '</a>' +
      '<div class="sg-line__info">' +
        '<a class="sg-line__name" href="' + item.url + '">' + item.product_title + '</a>' +
        (variant ? '<div class="sg-line__variant">' + variant + '</div>' : '') +
        '<div class="sg-line__row">' +
          '<span class="sg-line__price">' + (item.original_line_price > item.final_line_price ? '<s class="sg-line__was">' + moneyFmt(item.original_line_price) + '</s> ' : '') + moneyFmt(item.final_line_price) + '</span>' +
          '<span class="sg-line__qty">' +
            '<button type="button" data-sg-step="down" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="sg-line__qty-val">' + item.quantity + '</span>' +
            '<button type="button" data-sg-step="up" aria-label="Increase quantity">+</button>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="sg-line__remove" data-sg-remove aria-label="Remove item">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>' +
        '</button>' +
      '</div>';
    return li;
  }

  function render(cart) {
    if (!cache()) return;
    if (loadingEl) loadingEl.hidden = true;

    if (cart.item_count === 0) {
      itemsEl.hidden = true;
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      rewardsEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;
    itemsEl.hidden = false;
    itemsEl.innerHTML = '';
    cart.items.forEach(function (it) { itemsEl.appendChild(renderLine(it)); });
    totalEl.textContent = moneyFmt(cart.total_price);
    renderShipping(cart);
    renderRewards(cart);
  }

  /* 2026-11-03 Yellow (owner): short shipping line in the bag, in the shopper's currency; rate per country comes from the drawer's data attributes (snippet sg-ship-rate). */
  function renderShipping(cart) {
    var el = $('[data-sg-drawer-ship-value]', drawer);
    if (!el) return;
    var name = drawer.getAttribute('data-sg-ship-name') || 'DHL Standard';
    var usd = parseFloat(drawer.getAttribute('data-sg-ship-usd') || '0');
    var approx = drawer.getAttribute('data-sg-ship-approx') || '';
    if (usd === 0 || cart.total_price >= SHIP_THRESHOLD) { el.textContent = 'Free (' + name + ')'; el.classList.add('is-free'); return; }
    el.classList.remove('is-free');
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    var price;
    try { price = new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY }).format(usd * (CURRENCY === 'USD' ? 1 : rate)); }
    catch (e) { price = 'US$' + usd.toFixed(2); }
    el.textContent = name + ' ' + approx + price;
  }

  /* ── data ── */
  function refresh() {
    if (loadingEl && itemsEl.hidden && emptyEl.hidden) loadingEl.hidden = false;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { if (loadingEl) loadingEl.textContent = 'Could not load cart.'; });
  }

  function changeLine(key, qty) {
    drawer.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        updateHeaderCount(cart.item_count);
      })
      .catch(function () { refresh(); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  function updateHeaderCount(count) {
    var icon = $('.sg-header__icon--cart') || $('.cart-icon');
    if (!icon) return;
    var badge = icon.querySelector('.sg-header__cart-count');
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'sg-header__cart-count'; icon.appendChild(badge); }
      badge.textContent = count;
    } else if (badge) { badge.remove(); }
  }

  /* ── events ── */
  function bind() {
    if (!cache()) return;

    overlay.addEventListener('click', close);
    var closeBtn = $('[data-sg-drawer-close]', drawer);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // delegate stepper + remove
    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('.sg-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('.sg-line__qty-val');
      var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      if (e.target.closest('[data-sg-remove]')) { e.preventDefault(); changeLine(key, 0); return; }
      var step = e.target.closest('[data-sg-step]');
      if (step) {
        e.preventDefault();
        var dir = step.getAttribute('data-sg-step') === 'up' ? 1 : -1;
        var next = cur + dir;
        if (next < 0) next = 0;
        changeLine(key, next);
      }
    });

    // intercept cart-icon click → open drawer
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('.sg-header__icon--cart, .cart-icon, [data-sg-drawer-open]');
      if (cartLink) { e.preventDefault(); open(); }
    });

    // open after ATC (dispatched by fetch wrapper)
    document.addEventListener('sg:cart:added', function () { open(); });
  }

  /* ── wrap fetch to detect /cart/add success (hooks sgc-commerce.js without editing it).
       Uses a getter/setter so that if Shopify's web-pixel sandbox replaces window.fetch
       AFTER us, we transparently re-wrap the new implementation and keep the hook alive. ── */
  (function wrapFetch() {
    if (window.__sgFetchWrapped) return;
    window.__sgFetchWrapped = true;

    function makeWrapped(orig) {
      var wrapped = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var isAdd = url.indexOf('/cart/add') !== -1;
        var p = orig.apply(this, arguments);
        if (isAdd && p && p.then) {
          p.then(function (resp) {
            if (resp && resp.ok) {
              // let sgc-commerce.js finish its own /cart.js round-trip first
              setTimeout(function () { document.dispatchEvent(new CustomEvent('sg:cart:added')); }, 80);
            }
          }).catch(function () {});
        }
        return p;
      };
      wrapped.__sgWrapped = true;
      return wrapped;
    }

    var current = makeWrapped(window.fetch);
    try {
      Object.defineProperty(window, 'fetch', {
        configurable: true,
        get: function () { return current; },
        set: function (fn) {
          // someone (e.g. Shopify sandbox) is replacing fetch — re-wrap it so our hook survives
          current = (fn && fn.__sgWrapped) ? fn : makeWrapped(fn);
        }
      });
    } catch (e) {
      // fallback: plain assignment
      window.fetch = current;
    }
  })();

  function init() { bind(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
